module.exports = __webpack_public_path__ + "main/images/shared/microsoft365.a2dd9a565429443e54371ebdde032b0d.png";